<div class="fullscreen-loading" [class.--hide]="!show">
    <div class="fullscreen-loading__content">
        <img src="assets/icon/logox2.png" />
    </div>
</div>
